function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M122-223q-11-11-11.5-25.5T121-274l205-205q21-21 51-21t51 21l101 101 212-211h-81q-15.3 0-25.65-10.29Q624-609.58 624-624.79t10.35-25.71Q644.7-661 660-661h168q15.3 0 25.65 10.35Q864-640.3 864-625v168q0 15.3-10.29 25.65Q843.42-421 828.21-421t-25.71-10.06Q792-441.13 792-456v-82L580-326q-21 21-51 21t-51-21L377-428 173-223q-11 11-25.5 11T122-223Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#DDDDDD"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Variance.dcbdf8c7.svg";
export { SvgComponent as ReactComponent };